module.exports = __webpack_public_path__ + "img/popular-posts-3.c374700f.png";